import { Header } from '@lightspeed/design-system-react'
import React, { FC } from 'react'
import { LSPAYModalContent } from './LSPAYModalContent'

interface Props {
  headingType?: 'sub-heading' | 'heading'
}

export const CheckingPairing: FC<Props> = ({ headingType = 'heading' }) => {
  return (
    <LSPAYModalContent>
      <Header type={headingType} level="2">
        Checking pairing...
      </Header>
    </LSPAYModalContent>
  )
}
